/**
 * Created by Søren Tramm 2023.10.06
 */

import React, { Suspense } from 'react'
import { Link, Route, Routes, useParams } from 'react-router-dom'
import { Button } from 'antd'
import { SpinnerFullHeight } from '../../components/spinner/SpinnerFullHeight'
import { ProjectDrawer } from '../epro-project/ProjectDrawer'
import { CRUD_VIEW_TYPE } from '../../Types'
import { useProtocolById } from '../../hooks/useProtocolById'
import { PhaseCRUD } from '../phase/PhaseCRUD'
import { QuestionnaireCRUD } from '../questionnaire/QuestionnaireCRUD'
import { ProtocolHeader } from './ProtocolHeader'
import { ProtocolOverviewListItem } from './overview/ProtocolOverviewListItem'
import { ProtocolActivate } from './ProtocolActivate'
import { ProtocolCRUD } from './ProtocolCRUD'
import { QuestionManageDrawer } from '../questionnaire/question/QuestionManageDrawer'
import { QuestionCRUD } from '../questionnaire/question/QuestionCRUD'
import { useProject } from '../../hooks/useProject'
import { DeleteQuestionnaire } from '../questionnaire/DeleteQuestionnaire'
import { DeletePhase } from '../phase/DeletePhase'
import { PhaseOrderModal } from '../phase/PhaseOrderModal'
import { GroupCRUD } from '../group/GroupCRUD'
import { GroupClone } from '../group/GroupClone'
import { QuestionnaireClone } from '../questionnaire/QuestionniareClone'
import { PhaseClone } from '../phase/PhaseClone'

export const ProtocolDraftPage = () => {
  const { projectId, protocolId } = useParams() as { projectId: string; protocolId: string }
  // const { mutate: globalMutate } = useSWRConfig()
  const { data: protocolData, mutate } = useProtocolById(projectId, protocolId)
  const { data: projectData } = useProject(projectId)
  const defaultLanguage = projectData.languages[0].isoCode

  //  console.log('ProtocolDraftPage > protocolData = ', protocolData)

  const closeDrawer = (value) => {
    if (!value) {
      mutate()
    }
  }

  const deleteHeader = (
    <Link to="delete">
      <Button type="default" danger>
        Delete
      </Button>
    </Link>
  )

  return (
    <>
      <Routes>
        <Route
          path="/view-phase/:phaseId/*"
          element={
            <ProjectDrawer projectId={projectId} width="30%" to="../" header={deleteHeader} title="View phase">
              <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
                <PhaseCRUD closeDrawer={closeDrawer} viewType={CRUD_VIEW_TYPE.VIEW}></PhaseCRUD>
                <Routes>
                  <Route
                    path="/edit"
                    element={
                      <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
                        <ProjectDrawer projectId={projectId} width="30%" to="../">
                          <PhaseCRUD closeDrawer={closeDrawer} viewType={CRUD_VIEW_TYPE.UPDATE}></PhaseCRUD>
                        </ProjectDrawer>
                      </Suspense>
                    }
                  />
                  <Route
                    path="/delete"
                    element={
                      <>
                        <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
                          <ProjectDrawer
                            projectId={projectId}
                            width="20%"
                            setVisible={closeDrawer}
                            to="../../"
                            title="Delete phase"
                          >
                            <DeletePhase closeDrawer={closeDrawer}></DeletePhase>
                          </ProjectDrawer>
                        </Suspense>
                      </>
                    }
                  />
                </Routes>
              </Suspense>
            </ProjectDrawer>
          }
        />
        <Route
          path="/:phaseId/questionnaire/:questionnaireId/*"
          element={
            <ProjectDrawer projectId={projectId} width="30%" to="../" title="View questionnaire" header={deleteHeader}>
              <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
                <QuestionnaireCRUD closeDrawer={closeDrawer} viewType={CRUD_VIEW_TYPE.VIEW}></QuestionnaireCRUD>
                <Routes>
                  <Route
                    path="/edit"
                    element={
                      <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
                        <ProjectDrawer projectId={projectId} width="30%" to="../" title="Edit questionnaire">
                          <QuestionnaireCRUD
                            closeDrawer={closeDrawer}
                            viewType={CRUD_VIEW_TYPE.UPDATE}
                          ></QuestionnaireCRUD>
                        </ProjectDrawer>
                      </Suspense>
                    }
                  />
                  <Route
                    path="/delete"
                    element={
                      <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
                        <ProjectDrawer projectId={projectId} width="30%" to="../../">
                          <DeleteQuestionnaire closeDrawer={closeDrawer} />
                        </ProjectDrawer>
                      </Suspense>
                    }
                  />
                </Routes>
              </Suspense>
            </ProjectDrawer>
          }
        />
        <Route
          path="/create-phase"
          element={
            <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
              <ProjectDrawer projectId={projectId} width="30%" to="../" title="Add phase to protocol">
                <PhaseCRUD closeDrawer={closeDrawer}></PhaseCRUD>
                {/*<ProtocolAddPhase closeDrawer={closeDrawer} viewType="UPDATE" />*/}
              </ProjectDrawer>
            </Suspense>
          }
        />
        <Route
          path="/clone-phase/:phaseId/*"
          element={
            <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
              <ProjectDrawer projectId={projectId} width="400" setVisible={closeDrawer} to="../" title="Clone Phase">
                <PhaseClone />
              </ProjectDrawer>
            </Suspense>
          }
        />
        <Route
          path="phase/:phaseId/create-questionnaire"
          element={
            <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
              <ProjectDrawer projectId={projectId} width="30%" to={`../`} title="Add questionnaire">
                <QuestionnaireCRUD></QuestionnaireCRUD>
              </ProjectDrawer>
            </Suspense>
          }
        />

        <Route
          path="phase/:phaseId/create-group"
          element={
            <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
              <ProjectDrawer projectId={projectId} width="30%" to={`../`} title="Add Group">
                <GroupCRUD viewType={CRUD_VIEW_TYPE.CREATE}></GroupCRUD>
              </ProjectDrawer>
            </Suspense>
          }
        />

        <Route
          path="phase/:phaseId/group/:groupId/*"
          element={
            <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
              <ProjectDrawer projectId={projectId} width="30%" to={`../`} title="Edit Group" header={deleteHeader}>
                <GroupCRUD viewType={CRUD_VIEW_TYPE.VIEW}></GroupCRUD>
                <Routes>
                  <Route
                    path="/edit"
                    element={
                      <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
                        <ProjectDrawer projectId={projectId} width="30%" to="../">
                          <GroupCRUD viewType={CRUD_VIEW_TYPE.UPDATE}></GroupCRUD>
                        </ProjectDrawer>
                      </Suspense>
                    }
                  />

                  <Route
                    path="/delete"
                    element={
                      <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
                        <ProjectDrawer projectId={projectId} width="30%" to="../">
                          <h1>Delete</h1>
                        </ProjectDrawer>
                      </Suspense>
                    }
                  />
                </Routes>
              </ProjectDrawer>
            </Suspense>
          }
        />
        <Route
          path="phase/:phaseId/group/:groupId/questionnaire/create"
          element={
            <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
              <ProjectDrawer projectId={projectId} width="30%" to={`../`} title="Add group questionnaire">
                <QuestionnaireCRUD></QuestionnaireCRUD>
              </ProjectDrawer>
            </Suspense>
          }
        />

        <Route
          path="phase/:phaseId/group/:groupId/clone"
          element={
            <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
              <ProjectDrawer projectId={projectId} width="30%" to={`../`} title="Clone Group">
                <GroupClone closeDrawer={closeDrawer} />
              </ProjectDrawer>
            </Suspense>
          }
        />

        {/* <Route
          path="/:questionnaireId/clone"
          element={
            <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
              <ProjectDrawer projectId={projectId} width="30%" to={`../${protocolId}`} title="Clone questionnaire">
                <ProtocolQuestionnaireClone closeDrawer={closeDrawer} />
              </ProjectDrawer>
            </Suspense>
          }
        />*/}

        {/* ##########

        MANAGE QUESTIONS ON GROUP QUESTIONNIARE
        Duplicated code from below, but with a different path

        Also note that this must be above the below path "phase/:phaseId/group/:groupId/questionnaire/:questionnaireId/*"
        Since they are sharing the same basepath. But becuse this is ontop it matches this first


        ##########
        */}

        <Route
          path="phase/:phaseId/group/:groupId/questionnaire/:questionnaireId/manage-questions/*"
          element={
            <ProjectDrawer projectId={projectId} setVisible={closeDrawer} width={600} to="../" title="Manage Questions">
              <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
                <QuestionManageDrawer closeDrawer={closeDrawer}></QuestionManageDrawer>
                <Routes>
                  <Route
                    path="/update/:questionId"
                    element={
                      <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
                        <ProjectDrawer projectId={projectId} width="30%" to="../" title="Edit question">
                          <QuestionCRUD closeDrawer={closeDrawer} viewType={CRUD_VIEW_TYPE.UPDATE} />
                        </ProjectDrawer>
                      </Suspense>
                    }
                  />
                  <Route
                    path="/create"
                    element={
                      <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
                        <ProjectDrawer projectId={projectId} width="30%" to="../" title="Create question">
                          <QuestionCRUD closeDrawer={closeDrawer} viewType={CRUD_VIEW_TYPE.CREATE} />
                        </ProjectDrawer>
                      </Suspense>
                    }
                  />
                </Routes>
              </Suspense>
            </ProjectDrawer>
          }
        />

        {/* ########  Group questionnaires  ########

            VIEW and CRUD A GROUP QUESTIONNAIRE
            Very important for handling questionnaires inside a group

        */}

        <Route
          path="phase/:phaseId/group/:groupId/questionnaire/:questionnaireId/*"
          element={
            <ProjectDrawer projectId={projectId} setVisible={closeDrawer} to="../">
              {/* ########  VIEW group questionniare  ######## */}
              <QuestionnaireCRUD closeDrawer={closeDrawer} viewType={CRUD_VIEW_TYPE.VIEW}></QuestionnaireCRUD>
              <Routes>
                <Route
                  path="/edit"
                  element={
                    <ProjectDrawer projectId={projectId} width="30%" to="../">
                      <QuestionnaireCRUD closeDrawer={closeDrawer} viewType={CRUD_VIEW_TYPE.UPDATE}></QuestionnaireCRUD>
                    </ProjectDrawer>
                  }
                />
                <Route
                  path="/clone"
                  element={
                    <ProjectDrawer projectId={projectId} width="30%" to={`../../`} title="Clone Questionnaire">
                      <QuestionnaireClone closeDrawer={closeDrawer} />
                    </ProjectDrawer>
                  }
                />
              </Routes>
            </ProjectDrawer>
          }
        />

        <Route
          path="phase/:phaseId/questionnaire/:questionnaireId/*"
          element={
            <ProjectDrawer projectId={projectId} setVisible={closeDrawer} to="../">
              <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
                <QuestionnaireCRUD closeDrawer={closeDrawer} viewType={CRUD_VIEW_TYPE.VIEW}></QuestionnaireCRUD>
                <Routes>
                  <Route
                    path="/edit"
                    element={
                      <ProjectDrawer projectId={projectId} width="30%" to="../">
                        <QuestionnaireCRUD
                          closeDrawer={closeDrawer}
                          viewType={CRUD_VIEW_TYPE.UPDATE}
                        ></QuestionnaireCRUD>
                      </ProjectDrawer>
                    }
                  />
                </Routes>
              </Suspense>
            </ProjectDrawer>
          }
        />
        <Route
          path="/activate"
          element={
            <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
              {/*
              The redirect after cloninig works - because in the ProtocolWrapper there is a Navigate to
              Which automaticlly redirects to the active protocol
               */}
              <ProjectDrawer projectId={projectId} width="30%" to={`../../`} title="Activate protocol">
                <ProtocolActivate closeDrawer={closeDrawer} />
              </ProjectDrawer>
            </Suspense>
          }
        />

        <Route
          path="/view/*"
          element={
            <ProjectDrawer projectId={projectId} width="30%" to="../" title="View protocol">
              <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
                <ProtocolCRUD closeDrawer={closeDrawer} viewType={CRUD_VIEW_TYPE.VIEW} />
                <Routes>
                  <Route
                    path="/edit"
                    element={
                      <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
                        <ProjectDrawer projectId={projectId} width="30%" to="../" title="Edit protocol">
                          <ProtocolCRUD closeDrawer={closeDrawer} viewType={CRUD_VIEW_TYPE.UPDATE} />
                        </ProjectDrawer>
                      </Suspense>
                    }
                  />
                </Routes>
              </Suspense>
            </ProjectDrawer>
          }
        />

        <Route
          path="/order"
          element={
            <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
              <PhaseOrderModal phases={protocolData.phases} mutate={mutate}></PhaseOrderModal>
            </Suspense>
          }
        />

        {/* ##########

        MANAGE QUESTIONS ON PHASE QUESTIONNIARE
        Duplicated code from above, but with a different path

        ##########
        */}
        <Route
          path="/:phaseId/questionnaire/:questionnaireId/manage-questions/*"
          element={
            <ProjectDrawer projectId={projectId} setVisible={closeDrawer} width={600} to="../" title="Manage Questions">
              <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
                <QuestionManageDrawer closeDrawer={closeDrawer}></QuestionManageDrawer>
                <Routes>
                  <Route
                    path="/update/:questionId"
                    element={
                      <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
                        <ProjectDrawer projectId={projectId} width="30%" to="../" title="Edit question">
                          <QuestionCRUD closeDrawer={closeDrawer} viewType={CRUD_VIEW_TYPE.UPDATE} />
                        </ProjectDrawer>
                      </Suspense>
                    }
                  />
                  <Route
                    path="/create"
                    element={
                      <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
                        <ProjectDrawer projectId={projectId} width="30%" to="../" title="Create question">
                          <QuestionCRUD closeDrawer={closeDrawer} viewType={CRUD_VIEW_TYPE.CREATE} />
                        </ProjectDrawer>
                      </Suspense>
                    }
                  />
                </Routes>
              </Suspense>
            </ProjectDrawer>
          }
        />
      </Routes>

      <div className="container-fluid mb-5 ">
        <ProtocolHeader
          protocolData={protocolData}
          rightComponent={
            <div className="col-6 d-flex justify-content-end align-items-center mt-5">
              <Link to="view" className="me-2 ">
                <Button type="default" className="pb-3">
                  Edit protocol
                </Button>
              </Link>
              {protocolData.phases?.length ? (
                <Link to="activate" className="text-decoration-none">
                  <Button type="primary">Activate protocol</Button>
                </Link>
              ) : null}
            </div>
          }
        ></ProtocolHeader>

        <div className="row" style={{}}>
          <div className="col-4 d-flex justify-content-between my-6 ">
            <div className="d-flex align-items-center">
              <h4>Phases </h4>
              <p className="ms-2 mb-0 pb-1 opacity-75">({protocolData ? protocolData.phases?.length : 0})</p>
            </div>
          </div>
          <div className="col-8 d-flex justify-content-end my-6 ">
            <Link to="order">
              <Button className="me-2" type="default">
                Update order
              </Button>
            </Link>
            <Link to="create-phase">
              <Button type="default">Add phase</Button>
            </Link>
          </div>
        </div>

        {protocolData.phases?.map((phase, phaseIndex) => {
          return (
            <ProtocolOverviewListItem
              key={phaseIndex}
              phase={phase}
              protocol={protocolData}
              language={defaultLanguage}
            />
          )
        })}
      </div>
    </>
  )
}
